var _rect, _circle, _path, _rect2, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStep2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 80,
    viewBox: "0 0 101 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "changeColor",
    x: 0.248017,
    y: 0.248017,
    width: 100.199,
    height: 79.3655,
    rx: 7.68853,
    fill: "#31007A",
    fillOpacity: 0.08,
    strokeWidth: 0.496034
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "changeColor",
    cx: 50.3475,
    cy: 29.1487,
    r: 15.0159,
    fill: "#31007A",
    fillOpacity: 0.24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "changeColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.9623 35.93H45.732C45.4726 35.93 45.2615 35.7401 45.2615 35.5062V22.7911C45.2615 22.5571 45.4726 22.3673 45.732 22.3673H49.4999V25.8851C49.4999 27.2176 50.5315 28.301 51.8005 28.301H55.4336V35.5062C55.4336 35.7401 55.2217 35.93 54.9623 35.93ZM55.1361 26.6056H51.8005C51.4665 26.6056 51.1952 26.2827 51.1952 25.8851V22.3673H51.2902L55.1361 26.6056ZM56.9085 26.0359L52.2938 20.9499C52.1336 20.7727 51.9056 20.6719 51.6657 20.6719H45.732C44.5376 20.6719 43.5662 21.623 43.5662 22.7911V35.5061C43.5662 36.6742 44.5376 37.6253 45.732 37.6253H54.9623C56.1566 37.6253 57.1289 36.6742 57.1289 35.5061V26.6056C57.1289 26.3945 57.0501 26.1919 56.9085 26.0359Z",
    fill: "#8300DB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.4829,
    y: 59.1807,
    width: 77.7294,
    height: 5.29973,
    rx: 2.64987,
    fill: "#EDF1F7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "changeColor",
    x: 11.4829,
    y: 59.1807,
    width: 34.4483,
    height: 5.29973,
    rx: 2.64987,
    fill: "#8300DB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2);
export default __webpack_public_path__ + "static/media/step2.d2f0887d2a49db0d22e4eff9da2d97df.svg";
export { ForwardRef as ReactComponent };